import {
  getByIdProfileSelector,
  PROFILE_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'

export default function getMediaByIdProfileSelector (id) {
  return state => {
    const profile = getByIdProfileSelector(id)(state)
    return getValueReduxUtil(profile, PROFILE_KEY.MEDIA) || []
  }
}
